export default __webpack_public_path__ + "assets/sleet.132391bc.svg";